import React from 'react';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}
export function Input({
  className = '',
  type = 'text',
  ...props
}: InputProps) {
  return <input type={type} className={`flex h-10 w-full rounded-lg border border-input bg-background px-3 py-2 text-sm text-foreground ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 transition-shadow ${className}`} {...props} data-id="element-121" />;
}